<div class="breadcrumbs">
  <a class="breadcrumb-part" routerLink="/">
    <med-icon-home size="12"></med-icon-home>
  </a>
  <ng-container *ngFor="let item of breadcrumbs">
    <ng-container *ngIf="item.link else elseCase">
      <a class="breadcrumb-part" [routerLink]="item.link">{{ item.title }}</a>
    </ng-container>

    <ng-template #elseCase>
      <div class="breadcrumb-part">{{ item.title }}</div>
    </ng-template>


  </ng-container>

</div>
